import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartsRequest from "@/pages/PartsRequest";

export const Route = createFileRoute("/parts-request")({
  head: () => pageHead({
    title: 'Request a Part',
    description: "Can't find an RV part? Send Rex & Sons RVs a parts request and our team will track it down — serving Wilmington and Castle Hayne, NC.",
    path: '/parts-request',
  }),
  component: PartsRequest,
});
